interface IProps {
  children: JSX.Element | JSX.Element[];
  className?: string;
}

const Form = ({ children, className }: IProps) => {
  return (
    <div
      className={`border-2 border-gray-300 rounded-md w-full flex flex-col justify-start items-start ${className}`}
      onClick={(e) => {
        // e.preventDefault();
        e.stopPropagation();
      }}
    >
      {children}
    </div>
  );
};

export default Form;
